import { useLocation, useParams } from 'react-router';

type Page =
  | 'activity'
  | 'brands'
  | 'brandDetail'
  | 'brandSpecialDetail'
  | 'buyAgain'
  | 'category'
  | 'featured'
  | 'featuredCategory'
  | 'janeGold'
  | 'productDetail'
  | 'specialDetail'
  | 'reviews'
  | 'specials'
  | 'menu'
  | 'menuJaneGold';

export const useGetPage = (): Page => {
  const params = useParams();
  const location = useLocation();

  if (params['activity']) return 'activity';
  if (params['brand_id']) return 'brandDetail';
  if (params['rowId']) return 'featuredCategory';
  if (params['featured_category']) return 'featuredCategory';
  if (params['category']) return 'category';
  if (params['product_id']) return 'productDetail';
  if (params['special_id']) return 'specialDetail';
  if (params['brand_special_id']) return 'brandSpecialDetail';

  const pathParts = location.pathname.split('/');
  const lastPart = pathParts[pathParts.length - 1];

  if (lastPart === 'brands') return 'brands';
  if (lastPart === 'featured') return 'featured';
  if (lastPart === 'jane-gold') {
    if (pathParts.includes('menu')) return 'menuJaneGold';
    else return 'janeGold';
  }
  if (lastPart === 'reviews') return 'reviews';
  if (lastPart === 'specials') return 'specials';

  return 'menu';
};
